<template>
  <div id="overlay">
    <div class="center w-6/12">
      <div
        class="content border border-1 border-solid bg-white p-2 flex flex-col"
      >
        <div class="text-gray-800 text-3xl my-auto">Give Access</div>

        <t-rich-select
          multiple
          required
          clearable
          :close-on-select="false"
          :options="options"
          placeholder="Add Users"
          :value="selected"
          :classes="{
            wrapper: '',
            buttonWrapper: '',
            selectButton: 'bg-white border-gray-300',
            selectButtonLabel: '',
            selectButtonPlaceholder: 'text-gray-400',
            selectButtonIcon: 'text-gray-600',
            selectButtonClearButton: 'hover:bg-red-100 text-gray-600',
            selectButtonClearIcon: '',
            dropdown: 'bg-white border-gray-300',
            dropdownFeedback: 'pb-2 px-3 text-gray-400 text-sm',
            loadingMoreResults: 'pb-2 px-3 text-gray-400 text-sm',
            optionsList: '',
            searchWrapper: 'p-2 placeholder-gray-400',
            searchBox:
              'px-3 py-2 bg-gray-50 text-sm rounded border focus:outline-none focus:outline-none border-gray-300',
            optgroup: 'text-gray-400 uppercase text-xs py-1 px-2 font-semibold',
            option: '',
            disabledOption: '',
            highlightedOption: 'bg-red-100',
            selectedOption:
              'font-semibold bg-gray-100 bg-woo font-semibold text-white',
            selectedHighlightedOption:
              'font-semibold bg-gray-100 bg-woo font-semibold text-white',
            optionContent: 'flex justify-between items-center px-3 py-2',
            optionLabel: '',
            selectedIcon: '',
            enterClass: 'opacity-0',
            enterActiveClass: 'transition ease-out duration-100',
            enterToClass: 'opacity-100',
            leaveClass: 'opacity-100',
            leaveActiveClass: 'transition ease-in duration-75',
            leaveToClass: 'opacity-0',
          }"
        ></t-rich-select>

        <div class="w-full justify-end p-3 flex cursor-default">
          <div class="flex flex-row" style="width: 300px">
            <button
              :disabled="selected.length == 0"
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="submit"
            >
              Add
            </button>
            <button
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit('close')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Http, { OCR_ENDPOINTS, OCRBASE } from "../request";
import { TRichSelect } from "vue-tailwind/dist/components";
import VueTailwind from "vue-tailwind";

Vue.use(VueTailwind);
export default {
  props: {
    projectId: Number,
    allUsers: Array,
    selectedUsers: Array,
    name: String,
  },
  emits: ["allUsers"],

  components: {
    TRichSelect,
  },
  data() {
    return {
      selected: [],
      selectedId: [],
      filteredUsers: [],
      options: [],
    };
  },
  created() {
    this.filterUsers(this.allUsers, this.selectedUsers);
  },
  methods: {
    addUsers(id, list) {
      Http()
        .post(OCR_ENDPOINTS.main + this.name + "/" + id + "/users", {
          userIdList: list,
        })
        .then((response) => {
          this.filteredUsers = this.filteredUsers.filter(
            (o1) => !list.some((o2) => o1.id == o2)
          );

          this.$emit("updateUsers", response.data.users);
          this.$toast.success("User added successfully");
          this.selected = [];
          this.selectedId = [];
          this.options = [];
          this.formatUsers();
          this.$emit("close");
        })
        .catch((error) => {
          this.$toast.error(error.response.data);
        })
        .finally(() => {
          // this.displayProjectModal = false;
        });
    },

    submit() {
      for (var select of this.selected) {
        let obj = this.filteredUsers.find((o) => o.name == select);
        this.selectedId.push(obj.id.toString());
      }
      if (this.name == "projects") {
        this.addUsers(this.projectId, this.selectedId);
      } else if (this.name == "batches") {
        this.addUsers(this.projectId, this.selectedId);
      }
    },

    formatUsers() {
      for (var user of this.filteredUsers) {
        this.options.push(user.name);
      }
    },

    filterUsers(users, selectedUsers) {
      this.filteredUsers = users.filter(
        (o1) => !selectedUsers.some((o2) => o1.id === o2.id)
      );

      this.formatUsers();
    },
  },
};
</script>

<style scoped>

button {
  transition: all 0.3s;
  /* background-color: red; */
}

button:hover {
  background-color: gray !important;
}

button:disabled {
  background-color: gray !important;
}

:focus {
  outline: none;
}

.col-3 {
  position: relative;
}

/* necessary to give position: relative to parent. */
input[type="text"] {
  font: 15px/24px "Lato", Arial, sans-serif;
  color: #333;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: 1px;
}

.effect-16 {
  border: 0;
  padding: 4px 0;
  border-bottom: 1px solid #ccc;
  background-color: transparent;
}

.effect-16 ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #3399ff;
  transition: 0.4s;
}

.effect-16:focus ~ .focus-border,
.has-content.effect-16 ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}

.effect-16 ~ label {
  position: absolute;
  left: 0;
  width: 100%;
  top: 9px;
  color: #aaa;
  transition: 0.3s;
  z-index: -1;
  letter-spacing: 0.5px;
}

.effect-16:focus ~ label,
.has-content.effect-16 ~ label {
  top: -16px;
  font-size: 12px;
  color: #3399ff;
  transition: 0.3s;
}
</style>
